"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var defaultI18nProvider_1 = __importDefault(require("./defaultI18nProvider"));

exports.defaultI18nProvider = defaultI18nProvider_1.default;

var translate_1 = __importDefault(require("./translate"));

exports.translate = translate_1.default;

var TranslationProvider_1 = __importDefault(require("./TranslationProvider"));

exports.TranslationProvider = TranslationProvider_1.default; // Alias to translate to avoid shadowed variable names error with tsling

var withTranslate = translate_1.default;
exports.withTranslate = withTranslate;
exports.DEFAULT_LOCALE = 'en';

__export(require("./TranslationUtils"));

__export(require("./TranslationContext"));